var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2A5ADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4L10.5185 4.84404L6.48148 7.15596L5 8V16L6.48148 16.844L10.5556 19.156L12.037 20L13.5185 19.156L17.5185 16.844L19 16V8L17.5185 7.15596L13.4815 4.84404L12 4ZM7.96296 14.3119V9.68807L12 7.37615L16.037 9.68807V14.3119L12 16.6239L7.96296 14.3119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/LINK.8609b5ba2393a33c119708a8c13b2fe9.svg";
export { ForwardRef as ReactComponent };